import { TicketDetailTypes } from '../actions/ticketDetailAction';
import DateUtils from 'utils/date';

const initState = {
  isLoadingTicketDetail: false,
  ticketDetail: {},
  isLoadingAttachmentsExtension: false,
  attachmentConfig:{},
  isLoadingAttachmentsTicket: false,
  attachments:[],
  isLoadingActivities: false,
  timeLine: { item: {}, activities: [] },
  createdDateInit: '',
  errors: {},
};

const ticketDetailReducer = (state = initState, action: any) => {
  const { data, override, loading } = action;
  switch (action.type) {
    case TicketDetailTypes.FETCH_TICKET_DETAIL:
      return {
        ...state,
        errors: {},
        isLoadingTicketDetail: loading ?? true,
      };
    case TicketDetailTypes.FETCH_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingTicketDetail: false,
        ticketDetail: data
      };
    case TicketDetailTypes.FETCH_TICKET_DETAIL_FAIL:
      return {
        ...state,
        isLoadingTicketDetail: false
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_EXTENSION:
      return {
        ...state,
        isLoadingAttachmentsExtension: true,
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_EXTENSION_SUCCESS:
      return {
        ...state,
        attachmentConfig: data,
        isLoadingAttachmentsExtension: false,
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_EXTENSION_FAIL:
      return {
        ...state,
        isLoadingAttachmentsExtension: false,
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_TICKET:
      return {
        ...state,
        attachments: [],
        isLoadingAttachmentsTicket: true,
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_TICKET_SUCCESS:
      return {
        ...state,
        isLoadingAttachmentsTicket: false,
        attachments:data
      };
    case TicketDetailTypes.FETCH_ATTACHMENTS_TICKET_FAIL:
      return {
        ...state,
        isLoadingAttachmentsTicket: false,
      };
    case TicketDetailTypes.FETCH_ACTIVITIES:
      return {
        ...state,
        isLoadingActivities: true,
      };
    case TicketDetailTypes.FETCH_ACTIVITIES_SUCCESS:
      return {
        ...state,
        isLoadingActivities: false,
        timeLine: {
          item: data.item,
          activities: data.activities.reverse()
        },
        createdDateInit: DateUtils.formatDateTime(data?.item?.createdDate)
      };
    case TicketDetailTypes.FETCH_ACTIVITIES_FAIL:
      return {
        ...state,
        isLoadingActivities: false,
      };
    case TicketDetailTypes.TICKET_POST_ATTACHMENT:
      return {
        ...state,
        isLoadingAttachmentsTicket: true,
      };
    case TicketDetailTypes.TICKET_POST_ATTACHMENT_SUCCESS:
      return {
        ...state,
        isLoadingAttachmentsTicket: false,
      };
    case TicketDetailTypes.TICKET_POST_ATTACHMENT_FAIL:
      return {
        ...state,
        errors: { ...state.errors, attachments: data },
        isLoadingAttachmentsTicket: false,
      };
    case TicketDetailTypes.SET_ERRORS:
      return {
        ...state,
        errors: override ? data : { ...state.errors, ...data },
      };
    default:
      return state;
  }
}

export default ticketDetailReducer;
